/**
 * The Room's own brand mark.
 *
 * A deliberate ~15-line duplication of the shape @huaca/ui exports. That package has a single JS
 * entry point whose barrel names AuthProvider, HuacaClient and ModuleApp, so importing ANY component
 * from it — even a logo — pulls the entire authentication stack into a page served to anonymous
 * members of the public. Its stylesheet is a separate export and is safe to use, so this app takes
 * the CSS and draws its own mark.
 */
export function RoomMark({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" role="img" aria-label="Claro" focusable="false">
      <rect width="32" height="32" rx="8" fill="var(--color-accent, #476e66)" />
      <path d="M22 11.5a7 7 0 1 0 0 9" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
